// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth0 } from '../../react-auth0-spa';

import './styles.scss';
import getOrigin from '../../utils/getOrigin';
import { END_USERS_ROLE } from '../../utils/constants';
import '../DeleteAccount/styles.scss';

const LogOutLink = ({ rootStore, isMobile }) => {
  const { isAuthenticated, logout } = useAuth0();

  const { t } = useTranslation('account');

  if (!isAuthenticated) {
    return null;
  }

  const isEndUser = rootStore.profileStore.connection === END_USERS_ROLE;

  const logoutWithRedirect = () => {
    rootStore.sendLogoutNotification();
    logout({
      returnTo: getOrigin(isEndUser),
    });
  };

  return (
    <div className="logout-link-wrapper" onClick={() => logoutWithRedirect()}>
      {isMobile ? (
        <p className="nav-link cursor-pointer styled-link-logout">{t('menu.logOut')}</p>
      ) : (
        <div className="styled-logout-wrapper">
          <p className="delete-button-link">{t('menu.logOut')}</p>
        </div>
      )}
    </div>
  );
};

export default LogOutLink;
